import RNV_RUNTIME from "../../platformAssets/renative.runtime.json";
import { envFallbacks } from "../constants/common";

// Web-compatible environment configuration
export function env(key: string, fallback?: string): string | undefined {
  let value: string | undefined;

  // 1) Next.js / Node (SSR) / Web
  if (typeof process !== "undefined" && process.env && key in process.env) {
    value = process.env[key] || envFallbacks[key] || fallback;
  }
  // 2) ReNative injects globals (only if you set that up)
  else if (typeof global !== "undefined" && (global as any).__RNV_ENV?.[key]) {
    value = (global as any).__RNV_ENV[key] || envFallbacks[key] || fallback;
  }
  // 3) Web environment variables
  else if (typeof window !== "undefined" && (window as any).__ENV__?.[key]) {
    value = (window as any).__ENV__[key] || envFallbacks[key] || fallback;
  }
  // 4) ReNative runtime config - LAST HOPE
  else if (RNV_RUNTIME?.env?.[key]) {
    value = RNV_RUNTIME.env[key] || envFallbacks[key] || fallback;
  }
  // 5) Fallback to constants
  else {
    value = envFallbacks[key] || fallback;
  }

  // Debug logging for API URLs
  if (key.includes("API_URL") || key.includes("URL")) {
    // console.log(`[ENV] ${key} = ${value}`);
  }

  return value;
}
